<template>
    <footer id="footer">
        <v-container>
            <div class="footer-nav">
                <v-row>
                    <v-col class="footer-nav-item">
                        <Widget position="footer_menu_1" />
                    </v-col>
                    <v-col class="footer-nav-item">
                        <Widget position="footer_menu_2" />
                    </v-col>
                    <v-col class="footer-nav-item">
                        <Widget position="footer_menu_3" />
                    </v-col>
                    <v-col class="footer-nav-item">
                        <Widget position="footer_menu_4" />
                    </v-col>
                </v-row>
            </div>
            <div class="copiright">
                <Widget position="copiright"/>
            </div>
        </v-container>
    </footer>
</template>

<script>
import Widget from '@/components/app/Widget'

export default {
  name: 'Footer',
  components: {
    Widget
  }
}
</script>
